import ThemeApi from "./setting/theme";
import UserApi from "./user/user";
import MasterAdmin from "@api/masteradmin/masteradmin";
import PreferencesApi from "@api/setting/preferences";

export const userApi = new UserApi();
export const themeApi = new ThemeApi();
export const masterAdminApi = new MasterAdmin();
export const preferencesApi = new PreferencesApi();
